import React, { useEffect, useRef, useState } from "react";
import logoImg from "../../assets/images/logo.png";
import checkImg from "../../assets/images/check-2.svg";
import { Offcanvas } from "bootstrap";
import CandidateJobSection from "pages/CandidateJobSection/candidate-job-section";
import CandidatePersonalDetailsSection from "pages/CandidatePersonalDetailsSection/candidate-personal-details-sections";
import CandidateDocumentsSection from "pages/CandidateDocumentSection/candidate-documents-section";
import CandidateExperience from "pages/CandidateExperience/candidate-experience-section";
import { useUserContext } from "libs/context/UserContext";
import RoadTestModalSection from "pages/RoadTestModal/road-test-modal";
import CandidateConversationModal from "pages/CandidateConversationModal/candidate-conversation-model";
import CandidateCallbackModal from "pages/CandidateCallbackRequest/candidate-callback-request";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { capitalizeFirstLetter, formatUSPhone } from "helpers/GeneralHelper";
import CandidateBackgroundStatusInfoModal from "pages/CandidateBackgroundStatusInfo/candidate-background-status-info";
import CandidateVideoInterviewStatusInfoModal from "pages/CandidateVideoInterviewStatusInfo/candidate-video-interview-status-info-modal";
import CandidateOnboardingSection from "pages/CandidateOnboarding/candidate-onboarding";



const CandidateDashboard = () => {
  const [activeTab, setActiveTab] = useState("jobs"); // default tab
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarConversationOpen, setSidebarConversationOpen] = useState(false);
  const [testDateDateTimeValue, setTestDateDateTimeValue] = useState();
  const [requestCallBackModalOpen, setRequestCallBackModalOpen] = useState(false);
  const navigate = useNavigate();
  const { loading, candidateDetailsData } = useUserContext() || {};
  const InterestedOrNot = localStorage?.getItem("InterestedOrNot")
  const [InterestedValue, setInterested] = useState(false);
  const [requestBackgroundStatusInfoModalOpen, setBackgroundStatusInfoModalOpen] = useState(false);
  const [requestVideoInterviewStatusInfoModalOpen, setVideoInterviewStatusInfoModalOpen] = useState(false);
  const [roadTestRawStatus, setRoadTestRawStatus] = useState();


  let doctype = "";

  if (candidateDetailsData?.DriverDetails?.DLRequiredApproval === -1) doctype += (doctype ? ", " : "") + "DL";
  if (candidateDetailsData?.DriverDetails?.SSNRequiredApproval === -1) doctype += (doctype ? ", " : "") + "SSN";
  if (candidateDetailsData?.DriverDetails?.MECRequiredApproval === -1) doctype += (doctype ? ", " : "") + "MEC";


  const offcanvasRef = useRef(null);
  let offcanvasInstance = null;
  useEffect(() => {
    if (offcanvasRef.current) {
      offcanvasInstance = new Offcanvas(offcanvasRef.current);
    }
  }, []);
  // useEffect(() => {
  //   setInterested(false)
  //   if (InterestedOrNot == 'Not-Interested') {
  //     setActiveTab("personal")
  //     setInterested(false)
  //   }
  //   else if (InterestedOrNot == 'Interested') {
  //     setActiveTab("jobs")
  //     setInterested(true)
  //   }
  // }, [InterestedOrNot]);

  const openOffcanvas = () => {
    if (offcanvasInstance) {
      offcanvasInstance.show();
    }
  };

  const closeOffcanvas = () => {
    if (offcanvasInstance) {
      offcanvasInstance.hide();
    }
  };

  const uploadDocument = () => {
    setActiveTab('documents')
  }

  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Logout!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Logout",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result?.isConfirmed) {
        localStorage.clear()
        localStorage.removeItem("authUser");
        localStorage.removeItem("authUser");
        localStorage.removeItem("temp");
        navigate(`/login`)
      }
    });
  };

  // useEffect(() => {
  //   if (candidateDetailsData && candidateDetailsData?.CandidateClinetStatus == 'deactive') {
  //     setActiveTab("personal")
  //   }
  //   else if (candidateDetailsData && candidateDetailsData?.CandidateClinetStatus != 'deactive')
  //     {
  //     setActiveTab("jobs")
  //   }
  // }, [candidateDetailsData]);

  useEffect(() => {
    if (candidateDetailsData?.CandidateClinetStatus === 'deactive') {
      setActiveTab("personal");
      setInterested(false);
      return;
    }

    if (InterestedOrNot === 'Not-Interested') {
      setActiveTab("personal");
      setInterested(false);
    } else if (InterestedOrNot === 'Interested') {
      setActiveTab("jobs");
      setInterested(true);
    } else if (candidateDetailsData?.CandidateClinetStatus !== 'deactive') {
      setActiveTab("jobs");
    }
  }, [InterestedOrNot, candidateDetailsData]);


  return (
    <>
      <div className="main-wrapper">
        <section className="main-page profile-page-view">
          <div className="container-fluid">
            <div className="row justify-content-xl-end g-2 section-padding">
              {/* Logo */}
              {/* <div className="col-xl-1 col-12">
                <div className="floating-logo text-center">
                  <img src={logoImg} className="img-fluid" alt="logo" />
                </div>
              </div> */}

              {/* <div className="col-12">
                <div className="text-center">
                  <img src={logoImg} className="img-fluid candidate-dashboard-icon-pos" />
                </div>
              </div> */}

              <div className="col-12">
                <div className="d-flex justify-content-between align-items-center p-2 px-md-3 top-position-div">
                  {/* Left Logo */}
                  <div>
                    <img
                      src={logoImg}
                      className="img-fluid candidate-dashboard-logo"
                      alt="logo"
                    />
                  </div>

                  {/* Right Logout Icon */}
                  <button
                    className="btn btn-link text-danger p-0"
                    onClick={handleLogout}
                  >
                    {/* <i className="fas fa-sign-out-alt fa-lg"></i> */}
                    <div className="icon-button-new">
                      <a
                        // href={driverDetails.SSNImageLink}
                        target="_blank"
                        rel="noreferrer"
                        className="btn btn-link p-0 text-white"
                      >
                        {/* <i className="fas fa-sign-out-alt fa-lg"></i> */}
                        {/* <i className="bi bi-power"></i> */}
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="29" fill="currentColor" className="bi bi-power" viewBox="0 0 16 16">
                          <path d="M7.5 1v7h1V1z" />
                          <path d="M3 8.812a5 5 0 0 1 2.578-4.375l-.485-.874A6 6 0 1 0 11 3.616l-.501.865A5 5 0 1 1 3 8.812" />
                        </svg>
                      </a>
                    </div>
                  </button>
                </div>
              </div>

              <div className="col-xl-7 col-lg-12">
                <div className="left-dynamic-content px-lg-5 px-0">
                  <ul
                    className="nav nav-pills mb-0 mb-md-4 justify-content-center align-items-center gap-2"
                    id="profile-details-tab"
                    role="tablist"
                  >
                    <li className="nav-item" role="presentation">
                      {(((InterestedOrNot == 'Interested' || !localStorage?.getItem("InterestedOrNot")) && (candidateDetailsData?.CandidateClinetStatus != 'deactive')) && candidateDetailsData) &&
                        <button
                          // className="nav-link"
                          id="pills-PersonalDetails-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-PersonalDetails"
                          type="button"
                          role="tab"
                          aria-controls="pills-PersonalDetails"
                          aria-selected="true"
                          className={`nav-link ${activeTab === "jobs" ? "active" : ""}`}
                          onClick={() => setActiveTab("jobs")}
                        >
                          Jobs
                        </button>
                      }
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        // className="nav-link"
                        id="pills-PersonalDetails-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-PersonalDetails"
                        type="button"
                        role="tab"
                        aria-controls="pills-PersonalDetails"
                        aria-selected="true"
                        className={`nav-link ${activeTab === "personal" ? "active" : ""}`}
                        onClick={() => setActiveTab("personal")}
                      >
                        Personal Details
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        // className="nav-link"
                        id="pills-Documents-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-Documents"
                        type="button"
                        role="tab"
                        aria-controls="pills-Documents"
                        aria-selected="false"
                        className={`nav-link ${activeTab === "documents" ? "active" : ""}`}
                        onClick={() => setActiveTab("documents")}
                      >
                        Documents
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        // className="nav-link active"
                        id="pills-Experience-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-Experience"
                        type="button"
                        role="tab"
                        aria-controls="pills-Experience"
                        aria-selected="false"
                        className={`nav-link ${activeTab === "experience" ? "active" : ""}`}
                        onClick={() => setActiveTab("experience")}
                      >
                        Experience
                      </button>
                    </li>
                    {candidateDetailsData?.IsHired ?
                      <li className="nav-item" role="presentation">
                        <button
                          // className="nav-link active"
                          id="pills-Experience-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-Experience"
                          type="button"
                          role="tab"
                          aria-controls="pills-Experience"
                          aria-selected="false"
                          className={`nav-link ${activeTab === "onboarding" ? "active" : ""}`}
                          onClick={() => setActiveTab("onboarding")}
                        >
                          TSA PreCheck 
                        </button>
                      </li> : null
                    }
                  </ul>
                  <hr />
                  <div className="tab-content" id="pills-tabContent">
                    {activeTab === "jobs" && (
                      <>
                        <CandidateJobSection setActiveTab={setActiveTab} />
                      </>
                    )}
                    {activeTab === "personal" && (
                      <CandidatePersonalDetailsSection />
                    )}
                    {activeTab === "documents" && (
                      <CandidateDocumentsSection />
                    )}
                    {activeTab === "experience" && (
                      <CandidateExperience />
                    )}
                    {(activeTab === "onboarding" && candidateDetailsData?.IsHired) && (
                      <CandidateOnboardingSection />
                    )}
                  </div>
                </div>

              </div>

              {/* for web right side pannel */}

              {/* <div className="col-xl-4 bg-light">
                <div className="active-lg-device">
                  <div className="right-common-pattern px-4">
                    <div className="sec-title text-center">
                      <h2 className="text-secondary">Process Involved</h2>

                      <ul>
                        <li className="process-box d-flex align-items-center green-border">
                          <div className="text-details text-start">
                            <h5>Application Submitted</h5>
                            <p>31st March 2023</p>
                          </div>
                        </li>

                        <li className="process-box d-flex align-items-center green-border">
                          <div
                            className="text-details text-start d-flex align-items-center justify-content-between w-100">
                            <h5>Interview</h5>
                            <button className="btn btn-status bg-lightblue">
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-check2" viewBox="0 0 16 16">
                                <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" />
                              </svg>
                              Done
                            </button>
                          </div>
                        </li>

                        <li className="process-box d-flex align-items-center red-border">
                          <div
                            className="text-details text-start d-flex align-items-center w-100">
                            <h5>FADV Background Check</h5>
                          </div>
                        </li>

                        <li className="process-box d-flex align-items-center red-border">
                          <div
                            className="text-details text-start d-flex align-items-center justify-content-between w-100">
                            <h5>Drug Test</h5>
                            <button className="btn btn-status bg-lightblue">
                              <i className="bi bi-envelope me-1"></i>Check Email
                            </button>
                          </div>
                        </li>

                        <li className="process-box d-flex align-items-center red-border">
                          <div
                            className="text-details text-start d-flex align-items-center justify-content-between w-100">
                            <h5>MEC Test</h5>
                            <div className="d-flex gap-2">
                              <button className="btn btn-status bg-lightblue">
                                <i className="bi bi-eye me-1"></i>View
                              </button>
                              <button className="btn btn-status bg-lightblue">
                                <i className="bi bi-upload me-1"></i>Upload
                              </button>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="callback-btn px-4">
                    <div className="d-grid">
                      <button className="btn btn-callback" data-bs-toggle="modal"
                        data-bs-target="#callback_modal">
                        <img src="images/icons/phone.svg" className="img-fluid me-2" alt="" />
                        Request a Call Back
                      </button>
                    </div>
                  </div>
                </div>
              </div> */}
              {/* {InterestedValue && */}
              <div className="col-xl-4 bg-light">
                <div className="active-lg-device">
                  <div className="right-common-pattern px-4">
                    {(candidateDetailsData && (candidateDetailsData?.Interested) && (candidateDetailsData?.CandidateClinetStatus != 'deactive')) &&
                      <div className="sec-title text-center">
                        <h2 className="text-secondary">Process Involved</h2>

                        <ul>
                          <li
                            className={`process-box d-flex align-items-center ${candidateDetailsData?.CandidateClinetOrderStatus != 'Not Ordered' ? 'green-border' : 'red-border'}`}
                          >
                            {candidateDetailsData?.CandidateClinetOrderStatus &&
                              <div className="text-details text-start">
                                <h5>Background Status
                                  <span onClick={() => {
                                    setBackgroundStatusInfoModalOpen(true);
                                  }}>
                                    <i className="bx bxs-info-circle video-interview-info"></i>
                                  </span>
                                </h5>
                                <p>{candidateDetailsData?.CandidateClinetOrderStatus}</p>
                              </div>}
                          </li>
                          {candidateDetailsData?.CandidateTest?.map((allTests, index) => (

                            <li
                              className={`process-box d-flex align-items-center ${['yes', 'Yes'].includes(allTests?.TestStatus) ? 'green-border' : 'red-border'}`}
                              key={index}
                            >
                              <div className="text-details text-start d-flex align-items-center justify-content-between w-100 flex-wrap">
                                <h5 className="mb-2 mb-md-0">{allTests?.TestName} {[3, 18].includes(allTests?.JobRequireId) && (
                                  <>
                                    <span className="text-red-600">
                                      *
                                    </span>
                                  </>

                                )}
                                  {[17].includes(allTests?.JobRequireId) && (
                                    <span onClick={() => {
                                      setVideoInterviewStatusInfoModalOpen(true)
                                    }}>
                                      <i className="bx bxs-info-circle video-interview-info"></i>
                                    </span>
                                  )}
                                </h5>

                                {/* {['yes', 'Yes'].includes(allTests?.TestStatus) && (
                                <button className="btn btn-status bg-lightblue d-flex align-items-center justify-content-center px-2 py-0" style={{ minWidth: '70px', fontSize: '0.8rem' }}>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" className="bi bi-check2 me-1" viewBox="0 0 16 16">
                                    <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" />
                                  </svg>
                                  Done
                                </button>
                              )} */}

                                {(allTests?.TestName === 'Video Interview' && candidateDetailsData?.InterviewVideoLink) && (
                                  <button
                                    className="btn btn-status bg-lightblue d-flex align-items-center justify-content-center px-2 py-0 mt-2 mt-md-0"
                                    style={{ minWidth: '70px', fontSize: '0.8rem' }}
                                    onClick={() => window.open(candidateDetailsData.InterviewVideoLink, "_blank")}
                                  >
                                    {["no", "No"].includes(allTests?.TestStatus) ?
                                      <i className="fas fa-user-tie me-1" style={{ fontSize: '0.8rem' }}></i>
                                      :
                                      <i className="fas fa-eye me-1" style={{ fontSize: '0.8rem' }}></i>
                                    }
                                    {/* {["yes", "Yes"].includes(allTests?.TestStatus) ? 'View' : 'Take Interview'} */}
                                    {["no", "No"].includes(allTests?.TestStatus) ? 'Take Interview' : 'View'}
                                  </button>
                                )}
                                {((allTests?.TestName === 'Road test' && allTests?.TestStatus != "no" && allTests?.TestDateValueAppDateTimeFormat) || (allTests?.RawStatus == 'pending' && allTests?.TestName === 'Road test') || (allTests?.RawStatus == 'accepted' && allTests?.TestName === 'Road test')) && (

                                  // {allTests?.TestName === 'Road test' && allTests?.TestStatus == "no" && allTests?.TestDateValueAppDateTimeFormat && (
                                  <button
                                    className="btn btn-status bg-lightblue d-flex align-items-center justify-content-center px-2 py-0 mt-2 mt-md-0"
                                    style={{ minWidth: '70px', fontSize: '0.8rem' }}
                                    onClick={() => {
                                      setRoadTestRawStatus(allTests?.RawStatus)
                                      setTestDateDateTimeValue(allTests?.TestDateValueAppDateTimeFormat)
                                      setSidebarOpen(true);
                                    }}
                                  >
                                    <i className="fas fa-eye me-1" style={{ fontSize: '0.8rem' }}></i>
                                    View
                                  </button>
                                )}

                                {allTests?.AttachmentLink && !['Road test', 'Video Interview'].includes(allTests?.TestName) &&
                                  // <div 
                                  // // className="icon-button"
                                  // >

                                  <button
                                    className="btn btn-status bg-lightblue d-flex align-items-center justify-content-center px-2 py-0 mt-2 mt-md-0"
                                  >
                                    {/* <i className="bi bi-download"></i> */}
                                    <a
                                      href={allTests?.AttachmentLink}
                                      download
                                      rel="noopener noreferrer"
                                    >
                                      <i className="fas fa-eye me-1" style={{ fontSize: '0.8rem' }}></i>
                                      View
                                    </a>
                                    {/* style={{ minWidth: '70px', fontSize: '0.8rem' }} */}

                                  </button>
                                  // {/* </div> */}
                                }

                                {allTests?.TestName === 'DOT Medical Card' && (
                                  <button
                                    className="btn btn-status bg-lightblue d-flex align-items-center justify-content-center px-2 py-0 mt-2 mt-md-0"
                                    style={{ minWidth: '70px', fontSize: '0.8rem' }}
                                    onClick={e => {
                                      e.preventDefault();
                                      uploadDocument();
                                    }}
                                  >
                                    <i className="fas fa-upload me-1" style={{ fontSize: '0.8rem' }}></i>
                                    Upload
                                  </button>
                                )}
                              </div>




                            </li>
                          ))}

                          {/* <li
                          className="process-box d-flex align-items-center red-border"
                        >
                          <div
                            className="text-details text-start d-flex align-items-center w-100"
                          >
                            <h5>FADV Background Check</h5>
                          </div>
                        </li>

                        <li
                          className="process-box d-flex align-items-center red-border"
                        >
                          <div
                            className="text-details text-start d-flex align-items-center justify-content-between w-100"
                          >
                            <h5>Drug Test</h5>
                            <button className="btn btn-status bg-lightblue">
                              <i className="bi bi-envelope me-1"></i>Check Email
                            </button>
                          </div>
                        </li>

                        <li
                          className="process-box d-flex align-items-center red-border"
                        >
                          <div
                            className="text-details text-start d-flex align-items-center justify-content-between w-100"
                          >
                            <h5>MEC Test</h5>
                            <div className="d-flex gap-2">
                              <button className="btn btn-status bg-lightblue">
                                <i className="bi bi-eye me-1"></i>View
                              </button>
                              <button className="btn btn-status bg-lightblue">
                                <i className="bi bi-upload me-1"></i>Upload
                              </button>
                            </div>
                          </div>
                        </li> */}
                        </ul>
                        {(candidateDetailsData?.DriverDetails?.RequiredApproval === -1) &&
                          <p className="mt-2 text-red-600">Your document submission has been rejected. Please re-submit proper document or call us back if you need help.</p>
                        }
                        {(doctype && (candidateDetailsData?.DriverDetails?.RequiredApproval != -1) && (candidateDetailsData.DriverDetails.SSNRequiredApproval == -1 || candidateDetailsData.DriverDetails.DLRequiredApproval == -1 || candidateDetailsData.DriverDetails.MECRequiredApproval == -1)) && (
                          <p className="mt-2 text-red-600">
                            Your {doctype} document submission has been rejected. Please re-submit
                            proper document or call us back if you need help.
                          </p>
                        )}
                        {candidateDetailsData?.CandidateTest?.some(test => [3, 18].includes(test.JobRequireId)) && (
                          <p className="mt-2">
                            * To be conducted by {candidateDetailsData?.Client?.ClientName}
                          </p>
                        )}
                        <p className="mt-4">

                        </p>
                      </div>
                    }
                  </div>

                  {(candidateDetailsData && candidateDetailsData?.CanConversation) &&
                    <div className="callback-btn px-4">
                      <div className="d-grid">
                        <button
                          className="btn btn-callback"
                          onClick={() => setSidebarConversationOpen(true)}
                        >
                          <img
                            src="images/icons/phone.svg"
                            className="img-fluid me-2"
                            alt=""
                          />Start a conversation
                        </button>
                      </div>
                    </div>
                  }
                  {
                    // (candidateDetailsData && !candidateDetailsData?.CanConversation && InterestedValue) &&
                    (!candidateDetailsData?.CanConversation) &&
                    <div className="callback-btn px-4">
                      <div className="d-grid">
                        <button
                          className="btn btn-callback"
                          onClick={() => setRequestCallBackModalOpen(true)}
                        >
                          <img
                            src="images/icons/phone.svg"
                            className="img-fluid me-2"
                            alt=""
                          />
                          Request a callback
                        </button>
                      </div>
                    </div>
                  }
                  <div className="right-common-pattern mt-2 without-background-color">
                    <div className="sec-title text-center">
                      <div className="sec-title text-center">

                        {candidateDetailsData?.Recruiter &&
                          <p className="mt-2">Reach out to your Recruiter <strong>{capitalizeFirstLetter(candidateDetailsData?.Recruiter)} {candidateDetailsData?.RecruiterPhone? formatUSPhone(candidateDetailsData?.RecruiterPhone) : null}</strong> .</p>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* // } */}
            </div>
          </div>

          <RoadTestModalSection setSidebarOpen={setSidebarOpen} sidebarOpen={sidebarOpen} testDateDateTimeValue={testDateDateTimeValue} roadTestRawStatus={roadTestRawStatus} />
          <CandidateConversationModal setSidebarConversationOpen={setSidebarConversationOpen} sidebarConversationOpen={sidebarConversationOpen} />
          <CandidateCallbackModal setRequestCallBackModalOpen={setRequestCallBackModalOpen} requestCallBackModalOpen={requestCallBackModalOpen} />
          <CandidateBackgroundStatusInfoModal setBackgroundStatusInfoModalOpen={setBackgroundStatusInfoModalOpen} requestBackgroundStatusInfoModalOpen={requestBackgroundStatusInfoModalOpen} />
          <CandidateVideoInterviewStatusInfoModal setVideoInterviewStatusInfoModalOpen={setVideoInterviewStatusInfoModalOpen} requestVideoInterviewStatusInfoModalOpen={requestVideoInterviewStatusInfoModalOpen} />
        </section>
      </div>
    </>
  );
};

export default CandidateDashboard;
